var _style, _path, _path2, _path3;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 54 40",
    style: {
      enableBackground: "new 0 0 54 40"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#1E2228;stroke-width:2.025;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M41.6,25V6.2c0-2.3-1.9-4.2-4.2-4.2H5.7C3.3,2,1.4,3.9,1.4,6.2V25c0,7.2,5.9,13.1,13.1,13.1h13.9 C35.7,38.1,41.6,32.2,41.6,25z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M48.7,7.7h-6.9v18.6l3.8-0.6c3.8-0.6,6.6-3.8,6.8-7.6l0.3-6.1C52.8,9.6,51,7.7,48.7,7.7z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M47,10.9h-5.2v11.7l3.4-0.7c1.4-0.3,2.5-1.5,2.6-3l0.4-6.8C48.2,11.5,47.7,10.9,47,10.9z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutline);
export default __webpack_public_path__ + "static/media/outline.59cb2dad23b4e10d0917e00060e4207a.svg";
export { ForwardRef as ReactComponent };